const heroProduct = {
    heroProductVideoWrapper: undefined,
    cacheSelectors() {
        this.heroProductVideoWrapper = $('.plp__hero-video-wrapper');
    },

    attachObservable() {

        const options = {
            rootMargin: '0px',
            threshold:  [0.1, 0.9]
        }

        let heroObserver = new IntersectionObserver(this.observerCallback, options);

        $.each(this.heroProductVideoWrapper, (index, heroVideo) => {
            heroObserver.observe(heroVideo);
        });
    },

    observerCallback: (entries) => {
        const intersectingVideoElement = $(entries[0].target).find('video');

        entries[0].isIntersecting ?
                intersectingVideoElement.trigger('play') :
                intersectingVideoElement.trigger('pause');
    }
}

$(() => {
    heroProduct.cacheSelectors();
    heroProduct.attachObservable();
});

export default heroProduct;